// Dashboard.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../const";
import Navbar from '../../components/Navbar';

const Dashboard = () => {
  const [days, setDays] = useState(7);
  const [data, setData] = useState([]);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [responseText, setResponseText] = useState("");
  const storeId = localStorage.getItem("store");
  const navigate = useNavigate();

  const username = localStorage.getItem("username"); 
  const isAdmin = username === "admin";

  const warehouseOptions = [
    { value: "SELECT BRANDS (I) PVT. LTD. (PUNE)", label: "Pune" },
    { value: "SELECT BRANDS (I) PVT. LTD. (KOLKATA)", label: "Kolkata" },
    { value: "DELHI WAREHOUSE", label: "Delhi-1" },
  ];

  const [selectedWarehouse, setSelectedWarehouse] = useState(warehouseOptions[0].value);


  const fetchSummaryData = async (d = days) => {

    const storeIdToUse = isAdmin ? selectedWarehouse : storeId;
    const token = localStorage.getItem("token");
    // const storeId = localStorage.getItem("store");

    if (!token || !storeId) {
      console.warn("Missing token or store_id");
      return;
    }

    try {
      const res = await axios.get(`${BASE_URL}/get_summary_batch_data?days=${d}`, {
        headers: {
          Authorization: `Token ${token}`,
          Store: storeIdToUse,
        },
      });
      setData(res.data); // Expected to be an array
    } catch (err) {
      console.error("Error fetching summary data:", err);
    }
  };

  const addDataToDB = async () => {
    const token = localStorage.getItem("token");
    // const storeId = localStorage.getItem("store");

    const storeIdToUse = isAdmin ? selectedWarehouse : storeId;

    if (!token || !storeId) {
      alert("Missing token or store_id");
      return;
    }

    setIsRefreshing(true);
    setResponseText("");

    try {
      const res = await axios.post(
        `${BASE_URL}/add_batch_data`,
        {},
        {
          headers: {
            Authorization: `Token ${token}`,
            Store: storeIdToUse,
          },
        }
      );

      // console.log("Response from add_batch_data:", res.data);

      const message = typeof res.data === "string" ? res.data : "Refresh complete.";
      alert(message);
      setResponseText(message);
      fetchSummaryData(); // Refresh table after update
    } catch (err) {
      console.error("Error refreshing data:", err);
      alert("Error while refreshing data.");
      setResponseText("Error while refreshing data.");
    } finally {
      setIsRefreshing(false);
    }
  };

useEffect(() => {
  fetchSummaryData();
}, [days, selectedWarehouse]);


  const handleDaysChange = (e) => {
    setDays(parseInt(e.target.value));
  };

return (
  <div className="min-h-screen bg-gray-50">
    <Navbar title="Dashboard" />
    
    <div className="container mx-auto px-4 py-6">
      {/* Header and Controls */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
        <h1 className="text-2xl font-bold text-gray-800">Batch QC Dashboard</h1>
        {isAdmin ? (
              
              <div className="flex items-center gap-2">
              <label className="text-gray-700 font-medium whitespace-nowrap">Warehouse:</label>
              
              <select
                className="border border-gray-300 rounded-md px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={selectedWarehouse}
                onChange={(e) => setSelectedWarehouse(e.target.value)}
              >
                      
                  {warehouseOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
                </div>


              ) : (
                <h1 className="text-1xl text-gray-800">{storeId}</h1>
              )}

        
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2" style={{ marginBottom: "4px" }}>
            <label className="text-gray-700 font-medium whitespace-nowrap">Show:</label>
            <select
              className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={days}
              onChange={handleDaysChange}
            >
              <option value="7">Last 7 days</option>
              <option value="14">Last 14 days</option>
              <option value="30">Last 30 days</option>
            </select>
          </div>
          
          <button
            onClick={addDataToDB}
            disabled={isRefreshing}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md shadow transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {isRefreshing ? (
              <>
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4l4-4-4-4v4a8 8 0 00-8 8z"
                  />
                </svg>
                <span>Refreshing...</span>
              </>
            ) : (
              <>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
                </svg>
                <span>Refresh</span>
              </>
            )}
          </button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div 
          onClick={() => navigate("/batches_data")}
          className="bg-white rounded-xl shadow-md p-6 cursor-pointer hover:shadow-lg transition-shadow border-l-4 border-yellow-500"
        >
          <div className="flex justify-between items-center">
            <div>
              <p className="text-sm font-medium text-gray-500">QC Pending</p>
              <h3 className="text-2xl font-bold text-gray-800 mt-1">
                {data.length > 0 ? data[data.length - 1]?.total_pending ?? 0 : 0}
              </h3>
              <p className="text-sm text-gray-500 mt-1">
                As of {data.length > 0 ? data[data.length - 1]?.date : "-"}
              </p>
            </div>
            <div className="bg-yellow-100 p-3 rounded-full">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
          </div>
        </div>


      </div>

      {/* Response Message */}
      {responseText && (
        <div className={`mb-6 p-4 rounded-md ${responseText.includes("Error") ? "bg-red-100 text-red-800" : "bg-green-100 text-green-800"}`}>
          {responseText}
        </div>
      )}

      {/* Data Table */}
      <div className="bg-white rounded-lg shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase w-2/5">Date</th>
                <th className="px-2 py-2 text-center text-[0.65rem] font-medium text-gray-500 uppercase w-[12%]">Total<br/>Batches</th>
                <th className="px-2 py-2 text-center text-[0.65rem] font-medium text-gray-500 uppercase w-[12%]">QC<br/>Completed</th>
                <th className="px-2 py-2 text-center text-[0.65rem] font-medium text-red-600 uppercase w-[12%] bg-red-50">QC<br/>Pending</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100">
              {data.map((item, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-3 py-2 whitespace-nowrap text-sm font-medium text-gray-900">{item.date}</td>
                  <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-600 text-center">{item.total_batch_id}</td>
                  <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-600 text-center">{item.total_completed}</td>
                  <td className="px-2 py-2 whitespace-nowrap text-sm font-semibold text-red-600 text-center bg-red-50">
                    {item.total_pending}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
);
}
export default Dashboard;
